module.exports = __webpack_public_path__ + "static/media/white-logo.f30203c2.svg";